import type { CustomizationDraft, PiclickWP } from '@/types/piclick';

type StoreApiError = {
  code?: string;
  message?: string;
  data?: { status?: number };
};

export class AddToCartError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function addCustomizationToCart(
  draft: CustomizationDraft,
  options: PiclickWP
): Promise<void> {
  if (!options.anchorProductId) {
    throw new AddToCartError(
      'Produto base não configurado. Avise o suporte.',
      0
    );
  }

  const response = await fetch(options.storeApiUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Nonce: options.storeApiNonce,
    },
    body: JSON.stringify({
      id: options.anchorProductId,
      quantity: 1,
      extensions: {
        piclick: {
          sizeId: draft.sizeId,
          baseColorId: draft.baseColorId,
          accessoryId: draft.accessoryId,
          keys: draft.keys.map((k) => ({
            symbolId: k.symbolId,
            colorId: k.colorId,
            letterValue: k.letterValue,
          })),
        },
      },
    }),
  });

  if (!response.ok) {
    let message = 'Não foi possível adicionar à mochila.';
    try {
      const body = (await response.json()) as StoreApiError;
      if (body?.message) message = body.message;
    } catch {
      /* noop */
    }
    throw new AddToCartError(message, response.status);
  }
}
